module.exports = __webpack_public_path__ + "static/media/settings.d1c4733c.svg";